export const FALL_2024_DATA = {
  2024: {
    서울: {
      event: '추계',
      divisions: [
        {
          name: '1부',
          groups: [
            {
              name: '1조',
              teams: [
                '연세대 이글스',
                '한양대 라이온스',
                '한국외대 블랙나이츠',
                '고려대 타이거스',
              ],
              matches: [
                // 1조 경기 순서 및 결과 업데이트
                {
                  stage: '조별',
                  date: '2024-09-07 15:30',
                  location: '서울대 대운동장',
                  home: '한국외대 블랙나이츠',
                  away: '한양대 라이온스',
                  homeScore: 6,
                  awayScore: 27,
                  winner: '한양대 라이온스',
                },
                {
                  stage: '조별',
                  date: '2024-09-08 12:30',
                  location: '서울대 대운동장',
                  home: '연세대 이글스',
                  away: '고려대 타이거스',
                  homeScore: 36,
                  awayScore: 0,
                  winner: '연세대 이글스',
                },
                {
                  stage: '조별',
                  date: '2024-10-05 13:00',
                  location: '양평누리체육공원',
                  home: '한국외대 블랙나이츠',
                  away: '연세대 이글스',
                  homeScore: 0,
                  awayScore: 41,
                  winner: '연세대 이글스',
                },
                {
                  stage: '조별',
                  date: '2024-10-06 13:00',
                  location: '양평누리체육공원',
                  home: '한양대 라이온스',
                  away: '고려대 타이거스',
                  homeScore: 13,
                  awayScore: 9,
                  winner: '한양대 라이온스',
                },
                {
                  stage: '조별',
                  date: '2024-10-12 13:00',
                  location: '국민대 운동장',
                  home: '한국외대 블랙나이츠',
                  away: '고려대 타이거스',
                  homeScore: 13,
                  awayScore: 12,
                  winner: '한국외대 블랙나이츠',
                },
                {
                  stage: '조별',
                  date: '2024-10-13 18:00',
                  location: '약대울 체육공원',
                  home: '한양대 라이온스',
                  away: '연세대 이글스',
                  homeScore: 12,
                  awayScore: 14,
                  winner: '연세대 이글스',
                },
              ],
            },
            {
              name: '2조',
              teams: [
                '서울대 그린테러스',
                '국민대 레이저백스',
                '서울시립대 시티혹스',
                '동국대 터스커스',
              ],
              matches: [
                // 2조 경기 순서 및 결과 업데이트
                {
                  stage: '조별',
                  date: '2024-09-07 09:00',
                  location: '서울대 대운동장',
                  home: '서울대 그린테러스',
                  away: '서울시립대 시티혹스',
                  homeScore: 38,
                  awayScore: 7,
                  winner: '서울대 그린테러스',
                },
                {
                  stage: '조별',
                  date: '2024-09-08 15:30',
                  location: '서울대 대운동장',
                  home: '동국대 터스커스',
                  away: '국민대 레이저백스',
                  homeScore: 0,
                  awayScore: 36,
                  winner: '국민대 레이저백스',
                },
                {
                  stage: '조별',
                  date: '2024-10-06 15:30',
                  location: '약대울 체육공원',
                  home: '서울대 그린테러스',
                  away: '동국대 터스커스',
                  homeScore: 41,
                  awayScore: 6,
                  winner: '서울대 그린테러스',
                },
                {
                  stage: '조별',
                  date: '2024-10-06 18:00',
                  location: '약대울 체육공원',
                  home: '서울시립대 시티혹스',
                  away: '국민대 레이저백스',
                  homeScore: 0,
                  awayScore: 20,
                  winner: '국민대 레이저백스',
                },
                {
                  stage: '조별',
                  date: '2024-10-12 15:30',
                  location: '국민대 운동장',
                  home: '서울대 그린테러스',
                  away: '국민대 레이저백스',
                  homeScore: 27,
                  awayScore: 13,
                  winner: '서울대 그린테러스',
                },
                {
                  stage: '조별',
                  date: '2024-10-12 18:00',
                  location: '국민대 운동장',
                  home: '서울시립대 시티혹스',
                  away: '동국대 터스커스',
                  homeScore: 21,
                  awayScore: 19,
                  winner: '서울시립대 시티혹스',
                },
              ],
            },
          ],
          final: [
            // 결승전 결과 업데이트
            {
              stage: '결승전',
              date: '2024-10-19 19:30',
              location: '재현고등학교',
              home: '서울대 그린테러스',
              away: '연세대 이글스',
              homeScore: 7,
              awayScore: 19,
              winner: '연세대 이글스',
            },
          ],
          playoffs: [
            // 순위결정전 결과 업데이트
            {
              stage: '3,4위전',
              date: '2024-11-10 15:30',
              location: '효창운동장',
              home: '국민대 레이저백스',
              away: '한양대 라이온스',
              homeScore: 13,
              awayScore: 22,
              winner: '한양대 라이온스',
            },
            {
              stage: '5,6위전',
              date: '2024-11-10 13:00',
              location: '효창운동장',
              home: '서울시립대 시티혹스',
              away: '한국외대 블랙나이츠',
              homeScore: 16,
              awayScore: 6,
              winner: '서울시립대 시티혹스',
            },
            {
              stage: '7,8위전',
              date: '2024-10-20 17:00',
              location: '서울대 대운동장',
              home: '동국대 터스커스',
              away: '고려대 타이거스',
              homeScore: 8,
              awayScore: 10,
              winner: '고려대 타이거스',
            },
          ],
          promotion: [
            // 승강전 결과 업데이트
            {
              stage: '승강전',
              date: '2024-11-09 10:00',
              location: '효창 운동장',
              home: '고려대 타이거스',
              away: '홍익대 카우보이스',
              homeScore: 6,
              awayScore: 36,
              winner: '홍익대 카우보이스',
            },
          ],
        },

      ],
    },
  },
};

// 2024 · 서울 · 1부 팀 스탯 (StatTeam에 바로 넣어 쓰는 형태)
export const TEAM_STATS_2024_SEOUL_1 = [
  {
    team: '서울대 그린테러스',
    division: '1부',
    // 득점/경기
    points_per_game: 28.3,
    total_points: 113,
    total_touchdowns: 16,
    total_yards: 1628,
    yards_per_game: 407,
    // 런
    rushing_attempts: 183,
    rushing_yards: 1021,
    yards_per_carry: 5.6,
    rushing_yards_per_game: 255.3,
    rushing_td: 10,
    // 패스
    'pass_completions-attempts': '62-104',
    passing_yards: 607,
    passing_yards_per_passing_attempts: 5.8,
    passing_yards_per_game: 151.8,
    passing_td: 6,
    interceptions: 2,
    // 스페셜팀
    total_punt_yards: 1716,
    average_punt_yards: 42.9,
    touchback_percentage: '21.8%',
    'field_goal_completions-attempts': '3-3',
    yards_per_kick_return: 27.2,
    yards_per_punt_return: 12.5,
    total_return_yards: 1025,
    // 기타
    'fumble-turnover': '4-2',
    turnover_per_game: 1.1,
    turnover_rate: '+3',
    'penalty-pen_yards': '20-113',
    pen_yards_per_game: 28.3,
  },
  {
    team: '연세대 이글스',
    division: '1부',
    points_per_game: 27.5,
    total_points: 110,
    total_touchdowns: 15,
    total_yards: 1549,
    yards_per_game: 387.3,
    rushing_attempts: 129,
    rushing_yards: 631,
    yards_per_carry: 4.9,
    rushing_yards_per_game: 157.8,
    rushing_td: 6,
    'pass_completions-attempts': '72-97',
    passing_yards: 918,
    passing_yards_per_passing_attempts: 9.5,
    passing_yards_per_game: 229.5,
    passing_td: 9,
    interceptions: 1,
    total_punt_yards: 1828,
    average_punt_yards: 45.7,
    touchback_percentage: '21.2%',
    'field_goal_completions-attempts': '4-4',
    yards_per_kick_return: 29.3,
    yards_per_punt_return: 13.1,
    total_return_yards: 1148,
    'fumble-turnover': '3-2',
    turnover_per_game: 0.9,
    turnover_rate: '+4',
    'penalty-pen_yards': '25-180',
    pen_yards_per_game: 45.0,
  },
  {
    team: '한양대 라이온스',
    division: '1부',
    points_per_game: 18.5,
    total_points: 74,
    total_touchdowns: 9,
    total_yards: 1021,
    yards_per_game: 255.3,
    rushing_attempts: 158,
    rushing_yards: 713,
    yards_per_carry: 4.5,
    rushing_yards_per_game: 178.3,
    rushing_td: 7,
    'pass_completions-attempts': '20-42',
    passing_yards: 308,
    passing_yards_per_passing_attempts: 7.3,
    passing_yards_per_game: 77.0,
    passing_td: 2,
    interceptions: 2,
    total_punt_yards: 1648,
    average_punt_yards: 41.2,
    touchback_percentage: '19.2%',
    'field_goal_completions-attempts': '0-1',
    yards_per_kick_return: 25.1,
    yards_per_punt_return: 12.1,
    total_return_yards: 983,
    'fumble-turnover': '5-4',
    turnover_per_game: 1.3,
    turnover_rate: '+2',
    'penalty-pen_yards': '32-210',
    pen_yards_per_game: 52.5,
  },
  {
    team: '국민대 레이저백스',
    division: '1부',
    points_per_game: 20.5,
    total_points: 82,
    total_touchdowns: 11,
    total_yards: 1130,
    yards_per_game: 282.5,
    rushing_attempts: 142,
    rushing_yards: 623,
    yards_per_carry: 4.4,
    rushing_yards_per_game: 155.8,
    rushing_td: 8,
    'pass_completions-attempts': '32-67',
    passing_yards: 507,
    passing_yards_per_passing_attempts: 7.6,
    passing_yards_per_game: 126.8,
    passing_td: 3,
    interceptions: 2,
    total_punt_yards: 1576,
    average_punt_yards: 39.4,
    touchback_percentage: '18.7%',
    'field_goal_completions-attempts': '0-2',
    yards_per_kick_return: 22.3,
    yards_per_punt_return: 11.4,
    total_return_yards: 961,
    'fumble-turnover': '5-4',
    turnover_per_game: 1.4,
    turnover_rate: '0',
    'penalty-pen_yards': '28-195',
    pen_yards_per_game: 48.8,
  },
  {
    team: '서울시립대 시티혹스',
    division: '1부',
    points_per_game: 11.0,
    total_points: 44,
    total_touchdowns: 6,
    total_yards: 783,
    yards_per_game: 195.8,
    rushing_attempts: 191,
    rushing_yards: 603,
    yards_per_carry: 3.2,
    rushing_yards_per_game: 150.8,
    rushing_td: 5,
    'pass_completions-attempts': '22-51',
    passing_yards: 180,
    passing_yards_per_passing_attempts: 3.5,
    passing_yards_per_game: 45.0,
    passing_td: 1,
    interceptions: 3,
    total_punt_yards: 1604,
    average_punt_yards: 40.1,
    touchback_percentage: '16.3%',
    'field_goal_completions-attempts': '0-0',
    yards_per_kick_return: 23.4,
    yards_per_punt_return: 10.3,
    total_return_yards: 894,
    'fumble-turnover': '6-3',
    turnover_per_game: 2.1,
    turnover_rate: '-1',
    'penalty-pen_yards': '35-175',
    pen_yards_per_game: 43.8,
  },
  {
    team: '한국외대 블랙나이츠',
    division: '1부',
    points_per_game: 6.3,
    total_points: 25,
    total_touchdowns: 3,
    total_yards: 692,
    yards_per_game: 173.0,
    rushing_attempts: 185,
    rushing_yards: 581,
    yards_per_carry: 3.1,
    rushing_yards_per_game: 145.3,
    rushing_td: 2,
    'pass_completions-attempts': '12-36',
    passing_yards: 111,
    passing_yards_per_passing_attempts: 3.1,
    passing_yards_per_game: 27.8,
    passing_td: 1,
    interceptions: 4,
    total_punt_yards: 1536,
    average_punt_yards: 38.4,
    touchback_percentage: '12.7%',
    'field_goal_completions-attempts': '0-0',
    yards_per_kick_return: 20.2,
    yards_per_punt_return: 9.8,
    total_return_yards: 872,
    'fumble-turnover': '6-4',
    turnover_per_game: 1.9,
    turnover_rate: '-1',
    'penalty-pen_yards': '33-181',
    pen_yards_per_game: 45.3,
  },
  {
    team: '고려대 타이거스',
    division: '1부',
    points_per_game: 7.8,
    total_points: 31,
    total_touchdowns: 4,
    total_yards: 726,
    yards_per_game: 181.5,
    rushing_attempts: 174,
    rushing_yards: 598,
    yards_per_carry: 3.4,
    rushing_yards_per_game: 149.5,
    rushing_td: 3,
    'pass_completions-attempts': '15-41',
    passing_yards: 128,
    passing_yards_per_passing_attempts: 3.1,
    passing_yards_per_game: 32.0,
    passing_td: 1,
    interceptions: 5,
    total_punt_yards: 1488,
    average_punt_yards: 37.2,
    touchback_percentage: '9.5%',
    'field_goal_completions-attempts': '0-0',
    yards_per_kick_return: 19.8,
    yards_per_punt_return: 9.2,
    total_return_yards: 781,
    'fumble-turnover': '7-5',
    turnover_per_game: 2.6,
    turnover_rate: '-3',
    'penalty-pen_yards': '42-215',
    pen_yards_per_game: 53.8,
  },
  {
    team: '동국대 터스커스',
    division: '1부',
    points_per_game: 8.3,
    total_points: 33,
    total_touchdowns: 4,
    total_yards: 752,
    yards_per_game: 188.0,
    rushing_attempts: 203,
    rushing_yards: 692,
    yards_per_carry: 3.4,
    rushing_yards_per_game: 173.0,
    rushing_td: 3,
    'pass_completions-attempts': '16-45',
    passing_yards: 60,
    passing_yards_per_passing_attempts: 1.3,
    passing_yards_per_game: 15.0,
    passing_td: 1,
    interceptions: 6,
    total_punt_yards: 1412,
    average_punt_yards: 35.3,
    touchback_percentage: '9.2%',
    'field_goal_completions-attempts': '0-0',
    yards_per_kick_return: 18.6,
    yards_per_punt_return: 8.6,
    total_return_yards: 793,
    'fumble-turnover': '8-3',
    turnover_per_game: 2.8,
    turnover_rate: '-4',
    'penalty-pen_yards': '51-260',
    pen_yards_per_game: 65.0,
  },
];

const DIVISION = '1부';

// 숫자/쌍(예: "4-7") 토큰 식별
const isNumberToken = (t) => /^-?\d+(\.\d+)?$/.test(t);
const isPairToken = (t) => /^\d+-\d+$/.test(t);
const isStatToken = (t) => isNumberToken(t) || isPairToken(t) || /%$/.test(t);

// 값 파싱: "3-5"같은 쌍은 문자열 그대로, 나머지는 숫자
const parseVal = (t) => (isPairToken(t) ? t : parseFloat(t));

// 라인 파싱: "<등번호>번 <팀명 ...> <값...>"
function parseLine(line) {
  const tokens = line.trim().split(/\s+/);
  if (!tokens.length) return null;
  // 등번호 (예: "15번")
  const name = tokens[0]; // 화면에 name으로 노출
  let i = 1;
  const teamTokens = [];
  while (i < tokens.length && !isStatToken(tokens[i])) {
    teamTokens.push(tokens[i]);
    i += 1;
  }
  const team = teamTokens.join(' ');
  const statTokens = tokens.slice(i);
  return { name, team, stats: statTokens.map(parseVal) };
}

// 병합용 키
const keyOf = (pos, team, name) => `${pos}|${team}|${name}`;

// 스키마 정의(포지션/카테고리별)
const SCHEMA = {
  // QB
  'QB|패스': [
    'games', 'passing_attempts', 'pass_completions', 'completion_percentage',
    'passing_yards', 'passing_td', 'interceptions', 'longest_pass', 'sacks',
  ],
  'QB|런': [
    'games', 'rushing_attempts', 'rushing_yards', 'yards_per_carry',
    'rushing_td', 'longest_rushing',
  ],

  // RB
  'RB|런': [
    'games', 'rushing_attempts', 'rushing_yards', 'yards_per_carry',
    'rushing_td', 'longest_rushing', 'rushingFumbles', 'rushingFumblesLost',
  ],
  'RB|패스': [
    'games', 'targets', 'receptions', 'receiving_yards', 'yards_per_catch',
    'receiving_td', 'longest_reception', 'receiving_first_downs',
    'passingFumbles', 'passingFumblesLost',
  ],
  'RB|스페셜팀': [
    'games', 'kick_returns', 'kick_return_yards', 'yards_per_kick_return',
    'punt_returns', 'punt_return_yards', 'yards_per_punt_return', 'return_td',
  ],

  // WR
  'WR|패스': [
    'games', 'targets', 'receptions', 'receiving_yards', 'yards_per_catch',
    'receiving_td', 'longest_reception', 'receiving_first_downs',
    'passingFumbles', 'passingFumblesLost',
  ],
  'WR|런': [
    'games', 'rushing_attempts', 'rushing_yards', 'yards_per_carry',
    'rushing_td', 'longest_rushing', 'rushingFumbles', 'rushingFumblesLost',
  ],
  'WR|스페셜팀': [
    'games', 'kick_returns', 'kick_return_yards', 'yards_per_kick_return',
    'punt_returns', 'punt_return_yards', 'yards_per_punt_return', 'return_td',
  ],

  // TE
  'TE|패스': [
    'games', 'targets', 'receptions', 'receiving_yards', 'yards_per_catch',
    'receiving_td', 'longest_reception', 'fumbles', 'fumbles_lost',
  ],
  'TE|런': [
    'games', 'rushing_attempts', 'rushing_yards', 'yards_per_carry',
    'rushing_td', 'longest_rushing', 'fumbles', 'fumbles_lost',
  ],

  // K
  'K|스페셜팀': [
    'games', 'extra_points_attempted', 'extra_points_made',
    'field_goal', 'field_goal_percentage',
    'field_goal_1_19', 'field_goal_20_29', 'field_goal_30_39',
    'fiedl_goal_40_49', // 주의: 원본 컴포넌트 키에 오타가 있음(그대로 사용)
    'field_goal_50_plus', 'longest_field_goal',
  ],

  // P
  'P|스페셜팀': [
    'games', 'punt_count', 'punt_yards', 'average_punt_yard',
    'longest_punt', 'touchbacks', 'touchback_percentage',
    'inside20', 'inside20_percentage',
  ],

  // OL
  'OL|default': [
    'offensive_snaps_played', 'penalties', 'sacks_allowed',
  ],

  // DL/LB 공통 default
  'DL|default': [
    'games','tackles','TFL','sacks','forced_fumbles','fumble_recovery',
    'fumble_recovered_yards','pass_defended','interceptions',
    'interception_yards','touchdowns',
  ],
  'LB|default': [
    'games','tackles','TFL','sacks','forced_fumbles','fumble_recovery',
    'fumble_recovered_yards','pass_defended','interceptions',
    'interception_yards','touchdowns',
  ],

  // DB
  'DB|수비': [
    'games','tackles','TFL','sacks','forced_fumbles','fumble_recovery',
    'fumble_recovered_yards','pass_defended','interceptions',
    'interception_yards','touchdowns',
  ],
  'DB|스페셜팀': [
    'games', 'kick_returns', 'kick_return_yards', 'yards_per_kick_return',
    'punt_returns', 'punt_return_yards', 'yards_per_punt_return', 'return_td',
  ],
};

// 블록을 파싱해서 players 맵에 병합
function ingestBlock(playersMap, position, category, lines) {
  const schema = SCHEMA[`${position}|${category}`];
  lines
    .map((l) => l.trim())
    .filter((l) => l && !l.startsWith('//'))
    .forEach((line) => {
      const parsed = parseLine(line);
      if (!parsed) return;
      const { name, team, stats } = parsed;
      const k = keyOf(position, team, name);
      if (!playersMap.has(k)) {
        playersMap.set(k, { position, team, division: DIVISION, name });
      }
      const row = playersMap.get(k);
      schema.forEach((field, idx) => {
        row[field] = stats[idx] ?? row[field] ?? (isPairToken(field) ? '0-0' : 0);
      });
    });
}


// QB - 패스
const QB_PASS = [
  '15번 국민대 레이저백스 4 108 40 37.0 1084 8 8 52 1',
  '8번 서울대 그린테러스 4 76 38 46.2 450 2 6 56 0',
  '13번 연세대 이글스 3 39 30 76.9 663 3 0 46 0',
  '9번 한국외대 블랙나이츠 4 86 38 44.2 436 2 12 96 1',
  '19번 연세대 이글스 1 19 10 52.6 190 2 0 58 1',
  '30번 서울시립대 시티혹스 4 86 28 32.6 298 2 6 48 4',
  '15번 한양대 라이온스 4 72 36 50 492 8 8 34 0',
  '9번 고려대 타이거스 4 80 44 55 412 0 4 27 2',
  '1번 동국대 터스커스 4 68 16 23.5 378 4 0 71 0',
];

// QB - 런
const QB_RUN = [
  '15번 국민대 레이저백스 4 4 88 22 0 22',
  '8번 서울대 그린테러스 4 24 258 10.8 4 40',
  '13번 연세대 이글스 3 9 15 1.7 0 5',
  '9번 한국외대 블랙나이츠 4 8 -22 -2.7 0 0',
  '19번 연세대 이글스 1 3 -6 -2 0 0',
  '30번 서울시립대 시티혹스 4 10 -20 -2 2 3',
  '15번 한양대 라이온스 4 16 96 6 4 14',
  '9번 고려대 타이거스 4 20 72 3.6 0 12',
  '1번 동국대 터스커스 4 8 48 6 0 19',
];

// RB - 런
const RB_RUN = [
  '26번 한양대 라이온스 4 56 772 13.8 4 54 0 0',
  '35번 서울대 그린테러스 4 38 378 9.9 2 83 1 1',
  '21번 연세대 이글스 4 42 368 8.8 4 61 1 0',
  '18번 한국외대 블랙나이츠 4 52 270 5.2 0 44 0 0',
  '80번 동국대 터스커스 4 120 516 4.3 8 22 2 1',
  '7번 서울시립대 시티혹스 4 44 288 6.5 4 28 0 0',
  '5번 고려대 타이거스 4 24 116 3.5 0 9 0 0',
  '26번 국민대 레이저백스 4 8 80 10 0 18 0 0',
];

// RB - 패스
const RB_PASS = [
  '20번 한양대 라이온스 4 4 4 108 27 0 27 4 0 0',
  '35번 서울대 그린테러스 4 10 6 52 8.7 0 20 0 0 0',
  '21번 연세대 이글스 4 8 8 122 15.3 0 42 2 0 0',
  '18번 한국외대 블랙나이츠 4 4 4 24 6 0 11 0 0 0',
  '80번 동국대 터스커스 4 8 4 0 0 0 0 0 0 0',
  '20번 서울시립대 시티혹스 4 4 4 12 3 0 3 0 0 0',
  '18번 고려대 타이거스 4 4 4 -12 -3 -3 0 0 0 0 0',
  '28번 국민대 레이저백스 4 4 0 0 0 0 0 0 0 0',
];

// RB - 스페셜팀
const RB_ST = [
  '26번 한양대 라이온스 4 4 36 9 0 0 0 0',
  '7번 서울대 그린테러스 4 2 38 19 0 0 0 0',
  '21번 연세대 이글스 4 2 32 16 0 0 0 0',
  '18번 한국외대 블랙나이츠 4 2 18 9 0 0 0 0',
  '80번 동국대 터스커스 4 1 10 10 0 0 0 0',
  '20번 서울시립대 시티혹스 4 6 108 18 1 3 3 0',
  '18번 고려대 타이거스 4 0 0 0 3 12 4 0',
  '28번 국민대 레이저백스 4 2 4 2 0 0 0 0',
];

// WR - 패스
const WR_PASS = [
  '18번 한양대 라이온스 4 32 24 360 15 4 34 5 0 0',
  '24번 서울대 그린테러스 4 22 10 106 10.6 0 30 3 0 0',
  '88번 연세대 이글스 4 18 12 334 27.8 4 52 5 0 0',
  '20번 한국외대 블랙나이츠 4 24 8 332 41.5 4 77 4 0 0',
  '86번 동국대 터스커스 4 4 4 284 71 4 71 4 0 0',
  '84번 서울시립대 시티혹스 4 28 16 268 16.8 0 33 2 0 0',
  '20번 고려대 타이거스 4 32 24 232 9.7 0 27 2 0 0',
  '16번 국민대 레이저백스 4 28 12 416 34.7 4 52 8 0 0',
];

// WR - 런
const WR_RUN = [
  '18번 한양대 라이온스 4 6 24 4 0 15 0 0',
  '10번 서울대 그린테러스 4 6 38 6.3 0 15 0 0',
  '88번 연세대 이글스 4 2 24 12 0 12 0 0',
  '10번 한국외대 블랙나이츠 4 10 82 8.2 0 21 0 0',
  '13번 동국대 터스커스 4 4 16 4 0 5 0 0',
  '27번 서울시립대 시티혹스 4 4 4 1 0 0 0 0',
  '3번 고려대 타이거스 4 4 20 5 0 5 0 0',
  '19번 국민대 레이저백스 4 4 4 1 0 0 0 0',
];

// WR - 스페셜팀
const WR_ST = [
  '18번 한양대 라이온스 4 8 176 22 0 0 0 0',
  '9번 서울대 그린테러스 4 6 60 10 0 0 0 0',
  '28번 연세대 이글스 4 4 52 13 0 0 0 0',
  '20번 한국외대 블랙나이츠 4 4 212 53 0 0 0 0',
  '44번 동국대 터스커스 4 4 292 76 0 0 0 0',
  '86번 서울시립대 시티혹스 4 8 188 23.5 4 -8 -2 0',
  '3번 고려대 타이거스 4 0 0 0 4 12 3 0',
  '24번 국민대 레이저백스 4 8 84 10.5 0 0 0 0',
];

// TE - 패스
const TE_PASS = [
  '87번 한양대 라이온스 4 1 1 12 12 0 12 0 0',
  '86번 서울대 그린테러스 4 10 10 176 17.6 0 48 0 0',
  '18번 연세대 이글스 4 12 12 236 19.7 4 30 0 0',
  '87번 한국외대 블랙나이츠 4 2 1 8 8 0 8 0 0',
  '18번 동국대 터스커스 4 1 0 0 0 0 0 0 0',
  '87번 서울시립대 시티혹스 4 8 8 24 3 0 6 0 0',
  '32번 고려대 타이거스 4 3 2 22 11 0 13 0 0',
  '90번 국민대 레이저백스 4 2 1 15 15 1 15 0 0',
];
// TE - 런: "경기수 4, 나머지 0" (TE 패스에 나온 선수 전원)
const TE_RUN_ZERO = TE_PASS.map((line) => {
  const { name, team } = parseLine(line);
  return `${name} ${team} 4 0 0 0 0 0 0 0`;
});

// K
const K_ST = [
  '18번 한양대 라이온스 4 4 4 0-3 0 0-1 0-1 0-1 0-1 0 0',
  '8번 서울대 그린테러스 4 20 20 4-4 100 1-1 1-1 1-1 1-1 0 44',
  '21번 연세대 이글스 4 36 28 0-0 0 0 0 0 0 0 0',
  '10번 한국외대 블랙나이츠 4 3 3 0-0 0 0 0 0 0 0 0',
  '1번 동국대 터스커스 4 8 4 0-0 0 0 0 0 0 0 0',
  '27번 서울시립대 시티혹스 4 8 8 0-0 0 0 0 0 0 0 0',
  '20번 고려대 타이거스 4 2 1 0-0 0 0 0 0 0 0 0',
  '24번 국민대 레이저백스 4 4 4 1-2 50 1-2 0 0 0 0 18',
];

// P
const P_ST = [
  '88번 한양대 라이온스 4 4 208 52 52 0 0.0 1 25.0',
  '98번 서울대 그린테러스 4 12 336 28 44 4 33.3 4 33.3',
  '12번 연세대 이글스 4 8 294 36.8 46 0 0.0 2 25',
  '20번 한국외대 블랙나이츠 4 12 512 42.7 60 0 0.0 8 66.7',
  '1번 동국대 터스커스 4 24 772 32.2 60 0 0.0 8 33.3',
  '99번 서울시립대 시티혹스 4 20 944 47.2 57 4 20.0 8 40.0',
  '20번 고려대 타이거스 4 20 624 31.2 52 0 0.0 8 40.0',
  '24번 국민대 레이저백스 4 4 84 21 21 0 0.0 0 0.0',
];

// OL (공격 스냅 삭제 요청 → 0으로 채움)
const OL_DEF = [
  // name team  [offensive_snaps_played=0] penalties sacks_allowed
  '50번 국민대 레이저백스 0 1',
];

// DL
const DL_DEF = [
  '11번 한양대 라이온스 4 20 4 0 0 0 0 0 0 0 0',
  '50번 서울대 그린테러스 4 28 24 4 4 4 104 0 0 0 1',
  '77번 연세대 이글스 4 12 8 2 0 0 0 0 0 0 0',
  '78번 한국외대 블랙나이츠 4 16 0 0 0 0 0 0 0 0 0',
  '79번 동국대 터스커스 4 4 32 20 2.5 0 0 0 0 0 0 0',
  '58번 서울시립대 시티혹스 4 14 2 0 0 0 0 0 0 0 0',
  '61번 고려대 타이거스 4 20 4 4 0 0 0 0 0 0 0',
  '44번 국민대 레이저백스 4 16 0 0 0 0 0 0 0 0 0',
];

// LB
const LB_DEF = [
  '5번 한양대 라이온스 4 4 0 0 0 0 0 0 1 12 0',
  '89번 서울대 그린테러스 4 8 2 0 0 0 0 2 0 0 0',
  '41번 연세대 이글스 4 14 4 0 0 0 0 0 0 0 0',
  '69번 한국외대 블랙나이츠 4 24 0 0 0 0 0 0 1 0 0',
  '59번 동국대 터스커스 4 28 12 0 0 0 0 0 0 0 0',
  '99번 서울시립대 시티혹스 4 18 2 0 0 0 0 6 0 0 0',
  '15번 고려대 타이거스 4 12 0 0 0 0 0 0 0 0 0',
  '54번 국민대 레이저백스 4 18 2 0 4 0 0 0 0 0 0',
];

// DB - 수비
const DB_DEF = [
  '2번 한양대 라이온스 4 16 8 0 0 0 0 0 0 0 0',
  '9번 서울대 그린테러스 4 8 2 0 0 0 0 2 0 0 0',
  '28번 연세대 이글스 4 14 6 0 2 0 0 0 2 12 0',
  '10번 한국외대 블랙나이츠 4 20 0 0 0 0 0 2 1 13 0',
  '13번 동국대 터스커스 4 28 0 0 0 0 0 0 4 0 0',
  '33번 서울시립대 시티혹스 4 18 0 0 0 0 0 0 6 40 0',
  '20번 고려대 타이거스 4 12 0 0 0 0 0 0 0 0 0',
  '35번 국민대 레이저백스 4 24 0 0 0 0 0 0 0 0 0',
];

// DB - 스페셜팀
const DB_ST = [
  '27번 한양대 라이온스 4 4 60 15 0 0 0 0',
  '9번 서울대 그린테러스 4 6 60 10 0 0 0 0',
  '28번 연세대 이글스 4 4 52 13 0 0 0 0',
  '10번 한국외대 블랙나이츠 4 4 212 53 0 0 0 0',
  '13번 동국대 터스커스 4 4 292 76 0 0 0 0',
  '33번 서울시립대 시티혹스 4 8 188 23.5 4 -8 -2 0',
  '20번 고려대 타이거스 4 0 0 0 4 12 3 0',
  '35번 국민대 레이저백스 4 8 84 10.5 0 0 0 0',
];

/* ---------------------- 데이터 빌드 ---------------------- */

function build() {
  const map = new Map();

  ingestBlock(map, 'QB', '패스', QB_PASS);
  ingestBlock(map, 'QB', '런', QB_RUN);

  ingestBlock(map, 'RB', '런', RB_RUN);
  ingestBlock(map, 'RB', '패스', RB_PASS);
  ingestBlock(map, 'RB', '스페셜팀', RB_ST);

  ingestBlock(map, 'WR', '패스', WR_PASS);
  ingestBlock(map, 'WR', '런', WR_RUN);
  ingestBlock(map, 'WR', '스페셜팀', WR_ST);

  ingestBlock(map, 'TE', '패스', TE_PASS);
  ingestBlock(map, 'TE', '런', TE_RUN_ZERO);

  ingestBlock(map, 'K', '스페셜팀', K_ST);
  ingestBlock(map, 'P', '스페셜팀', P_ST);

  // OL: 스냅은 0으로 채움
  OL_DEF.forEach((line) => {
    const { name, team, stats } = parseLine(line);
    const k = keyOf('OL', team, name);
    if (!map.has(k)) map.set(k, { position: 'OL', team, division: DIVISION, name });
    const row = map.get(k);
    row.offensive_snaps_played = 0;
    row.penalties = stats[0] ?? 0;
    row.sacks_allowed = stats[1] ?? 0;
  });

  ingestBlock(map, 'DL', 'default', DL_DEF);
  ingestBlock(map, 'LB', 'default', LB_DEF);
  ingestBlock(map, 'DB', '수비', DB_DEF);
  ingestBlock(map, 'DB', '스페셜팀', DB_ST);

  return Array.from(map.values());
}

export const POSITION_STATS_2024_SEOUL_1 = build();
